import { SxProps, Theme } from '@mui/material';

export const CollectorProductCardSX: SxProps<Theme> = (theme) => ({
	position: 'relative',
	display: 'flex',
	p: '5px',
	gap: theme.spacing(1),
	alignItems: 'center',
	justifyContent: 'center',
	border: '1px solid rgba(153, 153, 153, 0.6)',
	'&:not(:last-child)': {
		borderRightWidth: 0,
	},
	img: {
		p: '5px',
		width: '50px',
		height: '50px',
		maxHeight: '100%',
		maxWidth: '100%',
		flexShrink: 0,
		objectFit: 'contain',
	},
});
